<template>
	<div class="home">
		<div>
			<NavBar :nav="false" />
			<div class="main inqform">
				<div class="title" v-if="datails.title">{{ datails.title }}</div>
				<van-form ref="inqForm" @submit="sub" :show-error="false" v-if="formKey">
					<div class="formItem">
						<div class="scan">
							<svg viewBox="0 0 1024 1024" version="1.1">
								<path
									d="M335.9 0c23.954 0 43.372 19.418 43.372 43.372 0 21.958-16.317 40.104-37.487 42.976l-5.885 0.396H168.03c-37.427 0-68.211 28.445-71.913 64.896l-0.373 7.39v185.475c0 23.954-19.418 43.372-43.372 43.372-21.958 0-40.104-16.316-42.976-37.486L9 344.505V159.031C9 74.453 75.024 5.297 158.343 0.29L168.03 0H335.9z m520.464 0c84.577 0 153.733 66.024 158.74 149.343l0.29 9.688v185.474c0 23.954-19.418 43.372-43.372 43.372-21.957 0-40.104-16.316-42.976-37.486l-0.396-5.886V159.031c0-37.428-28.444-68.212-64.895-71.914l-7.391-0.373h-167.87c-23.953 0-43.371-19.418-43.371-43.372 0-21.958 16.316-40.104 37.486-42.976L688.495 0h167.869z m115.658 636.123c21.958 0 40.104 16.316 42.976 37.486l0.396 5.886v185.474c0 84.578-66.024 153.734-149.343 158.74l-9.687 0.291h-167.87c-23.953 0-43.371-19.418-43.371-43.372 0-21.958 16.316-40.104 37.486-42.976l5.886-0.396h167.869c37.427 0 68.211-28.445 71.913-64.896l0.373-7.39V679.494c0-23.954 19.419-43.372 43.372-43.372z m-919.65 0c21.958 0 40.104 16.316 42.976 37.486l0.396 5.886v185.474c0 37.428 28.445 68.212 64.896 71.914l7.39 0.373H335.9c23.954 0 43.372 19.418 43.372 43.372 0 21.958-16.317 40.104-37.487 42.976l-5.885 0.396H168.03c-84.577 0-153.733-66.024-158.74-149.343L9 864.97V679.495c0-23.954 19.418-43.372 43.372-43.372z"
								/>
								<path
									d="M972.022 468.628c23.954 0 43.372 19.418 43.372 43.372 0 21.958-16.316 40.104-37.486 42.976l-5.886 0.396H52.372C28.418 555.372 9 535.954 9 512c0-21.958 16.317-40.104 37.487-42.976l5.885-0.396h919.65z"
								/>
							</svg>
							<p>名片识别</p>
						</div>
						<van-uploader class="uploader" :after-read="uploadFile" :max-count="1" :preview-image="false"><div></div></van-uploader>
					</div>
					<div class="formData">
						<div class="formItem">
							<span class="reg">姓名</span>
							<div class="inputBox">
								<van-field
									name="name"
									v-model="formData.name"
									placeholder=""
									:rules="[
										{ required: true, message: '请输入姓名' },
										{ validator: username, message: '姓名格式不正确' }
									]"
								/>
							</div>
						</div>
						<Inquire
							ref="Inquire"
							:formData="formData"
							@check="
								(name) => {
									formData.company = name;
								}
							"
						>
							<div class="formItem">
								<span class="reg">公司</span>
								<div class="inputBox">
									<van-field
										name="company"
										type="text"
										v-model="formData.company"
										placeholder="请输入公司"
										:rules="[{ required: true, message: '请输入公司' }]"
										@input="$refs.Inquire.queryCompany(formData.company)"
									/>
								</div>
							</div>
						</Inquire>
						<!-- <div class="formItem">
							<span class="reg">职位</span>
							<div class="inputBox">
								<van-field name="position" type="text" v-model="formData.position" placeholder="" :rules="[{ required: true, message: '请输入职位' }]" />
							</div>
						</div> -->
						<div class="formItem formPicker">
							<span class="reg">职位</span>
							<div class="inputBox">
								<van-field
									readonly
									clickable
									name="position"
									v-model="formData.position"
									placeholder="请选择"
									:rules="[{ required: true, message: '请选择' }]"
									@click="showPicker = true"
								/>
								<van-popup v-model="showPicker" position="bottom">
									<van-picker show-toolbar :columns="positionList" @confirm="onConfirm" @cancel="showPicker = false" />
								</van-popup>
							</div>
						</div>
						<div class="formItem email">
							<span class="reg">邮箱</span>
							<div class="inputBox">
								<van-field
									name="email"
									v-model="formData.email"
									placeholder=""
									:rules="[
										{ required: true, message: '请输入邮箱' },
										{ validator: email, message: '邮箱格式不正确' }
									]"
								/>
							</div>
						</div>
						<div class="formItem phone_code">
							<span class="reg">手机</span>
							<div class="inputBox">
								<van-field
									name="phone"
									type="tel"
									maxlength="11"
									v-model="formData.phone"
									placeholder=""
									:rules="[
										{ required: true, message: '请输入手机号' },
										{ validator: mobile, message: '请输入正确格式' }
									]"
								/>
							</div>
							<div class="clear"></div>
							<div class="inputBox notPosition">
								<van-field
									name="code"
									type="number"
									v-model="formData.code"
									placeholder="请输入验证码"
									:rules="[{ validator: verify_code, message: '请输入验证码' }]"
									autocomplete="off"
									maxlength="6"
								/>
								<p class="getCode" @click.stop="postCode()" :class="{ disabled: formData.timeKey }">
									{{ !formData.timeKey ? '发送验证码' : `${formData.time}秒后获取` }}
								</p>
							</div>
						</div>
						<div class="formItem formItemBox">
							<span class="reg more">您关注的3D打印材料</span>
							<van-field name="follow" placeholder="" :rules="[{ required: true, message: '至少选择一项' }]">
								<template #input>
									<van-checkbox-group v-model="formData.follow">
										<van-checkbox name="粉末材料" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											粉末材料
										</van-checkbox>
										<van-checkbox name="丝材材料" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											丝材材料
										</van-checkbox>
										<van-checkbox name="其它" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											其它
										</van-checkbox>
									</van-checkbox-group>
								</template>
							</van-field>
						</div>
						<div class="formItem formItemBox">
							<span class="reg more">您所在的行业</span>
							<van-field name="follow" placeholder="" :rules="[{ required: true, message: '至少选择一项' }]">
								<template #input>
									<van-checkbox-group v-model="formData.follow1">
										<van-checkbox name="打印设备商" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											打印设备商
										</van-checkbox>
										<van-checkbox name="打印服务商" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											打印服务商
										</van-checkbox>
										<van-checkbox name="终端行业用户" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											终端行业用户
										</van-checkbox>
									</van-checkbox-group>
								</template>
							</van-field>
						</div>
						<div class="formItem formItemBox">
							<span class="reg more">您关注的应用领域</span>
							<van-field name="follow" placeholder="" :rules="[{ required: true, message: '至少选择一项' }]">
								<template #input>
									<van-checkbox-group v-model="formData.follow2">
										<van-checkbox name="运动" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											运动
										</van-checkbox>
										<van-checkbox name="眼镜" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											眼镜
										</van-checkbox>
										<van-checkbox name="医疗" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											医疗
										</van-checkbox>
										<van-checkbox name="机器人" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											机器人
										</van-checkbox>
										<van-checkbox name="无人机" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											无人机
										</van-checkbox>
										<van-checkbox name="汽车" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											汽车
										</van-checkbox>
										<van-checkbox name="其他" shape="square">
											<template #icon="props">
												<img class="img-icon" v-if="props.checked" src="@/assets/images/check_on.png" />
												<img class="img-icon" v-else src="@/assets/images/check.png" />
											</template>
											其他
										</van-checkbox>
									</van-checkbox-group>
								</template>
							</van-field>
						</div>
						<div class="formItem">
							<span class="reg">您的产品需求</span>
							<div class="inputBox">
								<van-field
									name="name"
									type="textarea"
									v-model="formData.demand"
									placeholder="请您详细描述您的产品需求，我们将尽快安排相关负责同事与您联系"
									:rules="[{ required: true, message: '请输入产品需求' }]"
								/>
							</div>
						</div>

						<div class="formItem clause" style="padding-bottom: 0" @click="clause1 = !clause1">
							<van-checkbox v-model="clause1" :disabled="true">您同意赢创收集、使用、处理上述信息。</van-checkbox>
						</div>
						<div class="formItem clause" style="padding-bottom: 0" @click="clause = !clause">
							<van-checkbox v-model="clause" :disabled="true">
								您同意赢创为实现全球统一管理的市场营销活动目的将您提交的上述信息传送至我们的境外相关方。赢创将严格遵守信息安全和隐私保护的准则及相关法律法规要求，采取相应的安全保护措施，确保您的信息安全。点击阅读
								<a class="pdf" @click.stop="open_pdf">赢创隐私条款</a>
							</van-checkbox>
						</div>

						<div class="subBox" v-if="clause && clause1">
							<van-button :disabled="!clause" class="subBtn" native-type="submit">注册</van-button>
						</div>
					</div>
				</van-form>

				<div class="subBox" v-if="!clause || !clause1">
					<van-button class="subBtn" @click.stop="sub_ago">注册</van-button>
				</div>
			</div>
			<!-- <cg v-if="cgKey" :live-url="live_url" @close="cgKey = false" /> -->
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '@/config/config';
import NavBar from '@/components/NavBar.vue';
import Inquire from '@/components/Inquire.vue';
const regexp = {
	regexp_ch_phone: '^1[3456789]\\d{9}$',
	regexp_email: '^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z0-9]{2,6}$',
	regexp_company_email: '^[a-zA-Z0-9_.-]+@(qq.com|163.com|139.com|126.com|gmail.com|outlook.com)$',
	regexp_integer: '^[-\\+]?\\d+$',
	regexp_float: '^(-*(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*)))$'
};
const formData = {
	name: '',
	phone: '',
	code: '',
	email: '',
	timeKey: false,
	time: 60,
	follow: [],
	follow1: [],
	follow2: [],
	follow3: [],
	demand: '',
	company: '',
	position: '',
	is_lookstart: 0
};
export default {
	components: {
		// Cg
		NavBar,
		Inquire
	},
	data() {
		return {
			datails: {},
			clause: false,
			clause1: false,
			pdf: `https://evonik-wechat.oss-cn-shanghai.aliyuncs.com/privacy-policy/evonik-privacy-policy.pdf`,
			formKey: true,
			formData: {
				name: '',
				phone: '',
				code: '',
				email: '',
				timeKey: false,
				time: 60,
				follow: [],
				follow1: [],
				follow2: [],
				follow3: [],
				demand: '',
				company: '',
				position: '',
				is_lookstart: 0
			},
			showPicker: false,
			positionList: ['应用技术', '工程师', '市场', '采购', '研发', '销售']
		};
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({
			page_title: '注册'
		});
		this.initShare();
		this.get_lockstar();
		// this.getInfo(true);

		if (typeof window.QCC !== 'undefined') {
			this.initQCC();
		} else {
			// If QCC library is not loaded yet, set a timeout to retry
			let interval = setInterval(() => {
				if (typeof window.QCC !== 'undefined') {
					this.initQCC();
					clearInterval(interval);
				}
			}, 100);
		}
	},
	methods: {
		async uploadFile(file) {
			this.$dataStatistics({ page_title: '名片识别' });
			console.log('识别前', file);
			if (file && !file?.type?.includes('image/')) {
				this.subKey = true;
				let loading = Toast.loading({ message: '识别中...', forbidClick: true, overlay: true });
				await this.onRequest(file).then((res) => {
					console.log('处理前', res);
					const currentFormValue = {};
					res.result.item_list.map((item) => {
						if (item.key == 'name') {
							currentFormValue.name = item.value;
						} else if (item.key == 'company' && !currentFormValue.company) {
							currentFormValue.company = item.value;
						} else if (item.key == 'title') {
							// currentFormValue.job = item.value;
						} else if (item.key == 'address') {
							currentFormValue.address = item.value;
						} else if (item.key == 'email') {
							if (new RegExp(regexp.regexp_email).test(item.value)) {
								currentFormValue.email = item.value;
							}
						} else if (item.key == 'telephone' || item.key == 'work_tel') {
							// 避免是数字
							if (`${item?.value}`.includes('+86')) {
								item.value = `${item.value}`.replace('+86', '');
							}

							if (new RegExp(regexp.regexp_ch_phone).test(item.value)) {
								currentFormValue.phone = item.value;
							}
						}
					});
					console.log('处理后', currentFormValue);
					this.formData = {
						...this.formData,
						...currentFormValue
					};
					console.log('数据赋值', this.formData);
				});
				this.$nextTick(() => {
					this.setInputValue(this.formData.company);
					this.subKey = false;
					loading?.clear();
				});
			}
		},
		onRequest(file) {
			return new Promise((resolve) => {
				// 执行上传逻辑
				const formData = new FormData();
				formData.append('image', file.file, file.file.name);
				this.$http
					.post('https://api.lookstar.com.cn/tenant/third-party/text-in/business-card', formData)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						console.error(err);
						Toast('上传失败，请检查网络');
					});
			});
		},
		initQCC() {
			window.QCC.init({
				el: 'qcc_sdk',
				placeholder: '请输入公司',
				onSelect: (val) => {
					const value = val?.companyName || ``;
					console.log('onSelect', value);

					this.formData.company = value;
				},
				onChange: (val) => {
					console.log('onChange', val);
					this.formData.company = val;
				}
			});
		},
		setInputValue(value) {
			const inputElement = document.querySelector('#qcc_sdk input');
			if (inputElement) {
				inputElement.value = value;
				const event = new Event('input', {
					bubbles: true,
					cancelable: true
				});
				inputElement.dispatchEvent(event);

				inputElement.addEventListener('focus', () => {
					if (inputElement.value !== value) {
						inputElement.value = value;
					}
				});
			} else {
				console.error('没有找到输入元素 #qcc_sdk');
			}
		},
		get_lockstar() {
			this.$http.get(`/api/platform/send/openid?openid=${this.$localStorage.getItem('openid') || ''}`).then((res) => {
				if (res.data.errcode == 10301) {
					return;
				} else if (res.data.errcode == 500) {
					return;
				} else {
					this.formData.is_lookstart = 1;
					formData.is_lookstart = 1;
					if (!this.formData.name) this.formData.name = res.data.full_name || ``;
					if (!this.formData.phone) this.formData.phone = res.data.plaintext_data.phone || ``;
					if (!this.formData.email) this.formData.email = res.data.plaintext_data.email || ``;
					if (!this.formData.company) {
						this.formData.company = res.data.company || ``;
						this.setInputValue(res.data.company || ``);
					}
					if (!this.formData.position) this.formData.position = res.data.job || ``;
				}
			});
		},
		postCode() {
			if (this.formData.timeKey == true) return; //阻止倒计时点击

			this.$refs.inqForm.validate('phone').then((res) => {
				this.formData.timeKey = true; //关闭按钮
				// console.log(this.formData);

				var int = setInterval(() => {
					this.formData.time--;

					if (this.formData.time == 0) {
						this.formData.timeKey = false; //打开按钮

						this.formData.time = 60; //重置时间

						return clearInterval(int); //清除计时器
					}
				}, 1000);

				this.getCode();
			});
		},
		getCode() {
			let crypt = new Crypt(config.crypto.publickey);
			let data = {
				crypt_key: crypt.rsa_key_encrypt(), //加密公钥传参
				phone: crypt.aes_encrypt(this.formData.phone) //加密手机号
			};
			this.$http
				.post(`/api/platform/send`, data)
				.then((res) => {
					if (res.data.errcode) return;
					Toast('发送成功,请注意查收');
					// console.log(res, 'in this');
				})
				.catch((err) => {});
		},
		sub_ago() {
			if (!this.clause || !this.clause1) {
				Toast('请勾选隐私协议');

				let height = document.body.scrollHeight;
				setTimeout(() => {
					window.scrollTo(0, height);
				}, 0);
				return;
			}
		},
		failed() {},
		sub() {
			this.formData.name.replace(/^\s\s*/, '').replace(/\s\s*$/, ''); //姓名收尾去除空格
			this.formData.email.replace(/ /g, ''); //邮箱去除空格
			let data = JSON.parse(JSON.stringify(this.formData)); //防止污染

			delete data.time;
			delete data.timeKey;

			let crypt = new Crypt(config.crypto.publickey);
			data.crypt_key = crypt.rsa_key_encrypt(); //加密公钥传参

			data.name = crypt.aes_encrypt(data.name);
			data.phone = crypt.aes_encrypt(data.phone);
			data.email = crypt.aes_encrypt(data.email);
			data.openid = this.$localStorage.getItem('openid');

			data.source = this.$route.query?.id * 1 || '';
			data.origin = this.$route.query?.origin || '3D';

			console.log(data);

			this.$http
				.post(`/api/platform/user`, data)
				.then((res) => {
					console.log(res);
					if (res.data.errcode) {
						return Toast(res.data.errmsg);
					}

					this.formData = formData;
					// this.$dataStatistics('click', '注册');
					this.$dataStatistics({ event_type: 'click', page_title: '注册' }, { tag: this.datails?.label });
					// this.getInfo();

					this.formKey = false;
					this.$nextTick(() => {
						this.formKey = true;
						// this.cgKey = true;

						Toast({
							message: '注册成功!',
							overlay: true,
							duration: 1500,
							className: ['toast']
						});

						setTimeout(() => {
							this.$router.replace({ path: `/${this.$route.query?.path}`, query: { id: this.$route.query?.id } });
						}, 1500);
					});
				})
				.catch((err) => {});
		},
		getInfo(key = false) {
			this.$http.get(`/api/platform/user?polyv=${this.$route.query?.polyv}&source=${this.$route.query?.source || ''}`).then((res) => {
				console.log('info', res.data);
				if (res.data.errcode == 1040) {
					return;
				}
				// if (res.data.code == 0) {
				// 	this.live_url = res.data.live_url;
				// 	if (key) {
				// 		this.$router.go(-1);
				// 	}
				// }
			});

			let datails = JSON.parse(localStorage.getItem(`cibf_datails_${this.$route.query?.source}_${process.env.VUE_APP_BLUE_DOT || ''}`)) || {};
			this.datails = datails;
			if (this.datails && this.datails.title) document.title = this.datails.title;
			this.$http.get(`/api/platform/module/${this.$route.query?.source || ''}?filter[type]=2`).then((res) => {
				// console.log('res', res);
				this.datails = res?.data || {};
				if (this.datails && this.datails.title) document.title = this.datails.title;
			});
		},
		username(val) {
			let key = true;
			let nameLang = val.length;
			if (nameLang > 9 || nameLang < 2) key = false; //姓名最少2位，最大9位
			if (!isNaN(val)) key = false; //姓名不能为纯数字
			return key;
		},
		mobile(val) {
			return this.$store.state.phoneReg.test(val);
		},
		email(val) {
			return this.$store.state.emailReg.test(val);
		},
		verify_code(val) {
			if (!this.formData.phone) {
				return true;
			} else {
				if (!this.formData.code) return false;
				return true;
			}
		},
		open_pdf() {
			location.href = this.pdf;
		},
		onConfirm(value) {
			this.formData.position = value;
			this.showPicker = false;
		}
	}
};
</script>
<style lang="less" scoped>
::v-deep .van-radio__icon .van-icon,
::v-deep .van-checkbox__icon .van-icon {
	width: 29px;
	height: 28px;
	background: #e4e1df;
	border: 1px solid #999999;
	border-radius: 50%;
	font-size: 0.4em;
}

::v-deep .van-radio__icon--checked .van-icon,
::v-deep .van-checkbox__icon--checked .van-icon {
	border: 1px solid #991d85;
	background: #991d85;
}

.formPicker {
	::v-deep .van-field__body {
		position: relative;
	}

	::v-deep .van-field__body::after {
		content: '';
		position: absolute;
		top: 30px;
		right: 0;
		width: 18px;
		height: 18px;
		border-bottom: 1px #333333 solid;
		border-right: 1px #333333 solid;
		transform: rotate(45deg);
	}
}

.int {
	display: none !important;

	::v-deep .van-overlay,
	::v-deep .van-popup {
		z-index: -1 !important;
		background: none;
	}
}

.home {
	background: rgba(249, 247, 243, 0.66);

	.bg {
		position: fixed;
		top: calc(435px + 90px + 60px);
		left: 240px;
		z-index: 4;
		transform: translateX(-100%) translateY(-100%);
		display: block;
		width: 412px;
		height: 415px;
	}

	.bg2 {
		position: fixed;
		right: 472px;
		bottom: 0;
		z-index: 4;
		transform: translateX(100%) translateY(282px);
		display: block;
		width: 561px;
		height: 564px;
	}

	.title {
		padding-left: 30px;
		font-size: 32px;
		font-weight: normal;
		color: #000000;
		line-height: 1.5;
		position: relative;
		margin-bottom: 29px;
		-webkit-text-stroke: 0.6px;
		white-space: break-spaces;
		word-wrap: break-word;
		word-break: break-all;
		&::before {
			content: '';
			display: block;
			position: absolute;
			// top: 50%;
			top: calc(32px * 1.5 / 2);
			left: 0;
			transform: translateY(-50%);
			z-index: 1;
			width: 10px;
			height: 30px;
			background: #a74499;
		}
	}

	.main {
		width: 828px;
		padding: 40px 30px 32px;
		position: relative;
		height: auto;
		z-index: 1;
	}

	.inqform {
		.formData {
		}

		.phone_code {
			.clear {
				height: 20px;
			}
		}

		.formItem {
			display: flex;
			flex-wrap: wrap;
			padding: 20px 0;
			position: relative;

			&:first-child {
				padding-top: 0;
			}

			&:last-child {
				padding-bottom: 0;
			}

			& .scan {
				width: 100%;
				flex: 0 0 auto;
				display: flex;
				align-items: center;
				padding: 20px 0;
				margin: -20px 0;
				position: relative;
				font-weight: 900;

				&::after {
					content: '上传名片帮您快速填写表单';
					font-size: 26px;
					color: #999;
					margin-left: 22px;
					font-weight: 400;
				}

				svg {
					width: 36px;
					height: 36px;
					fill: @theme;
					margin-right: 12px;
				}

				p {
					color: @theme;
					text-decoration: underline;
					display: inline-block;
					font-size: 32px;
				}
			}

			#qcc_sdk {
				width: 100% !important;
				flex: 0 0 auto !important;

				/deep/.qcc-component-autocomplete {
					width: 100% !important;

					.qcc-input-affix-wrapper {
						padding: 0 !important;
						border: none !important;
					}

					.qcc-input {
						width: 100% !important;
						height: 100% !important;
					}

					& * {
						background-color: transparent !important;
					}
				}
			}
		}

		/deep/.formItem > span,
		/deep/.van-field__label {
			font-size: 32px !important;
			color: #000 !important;
			width: 100% !important;
			flex: 0 0 auto;
			display: block;
			line-height: 1;
			margin-bottom: 20px;
			padding-left: 4px;
		}

		/deep/.van-checkbox,
		/deep/.van-radio {
			margin-bottom: 40px;

			&:last-child {
				margin-bottom: 0;
			}

			span {
				font-size: 30px !important;
				font-weight: 500;
				color: #999999 !important;
				padding: 0;
				margin: 0;
			}

			.van-checkbox__icon,
			.van-radio__icon {
				width: auto;
				height: auto;
				margin-right: 16px;
				line-height: 1;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.img-icon {
				width: 23px;
				height: 23px;
				display: inline-block;
			}
		}

		.formItem input {
			flex: 0;
			max-width: 100% !important;
			color: #000;
			font-size: 30px;
		}

		.formItem input::placeholder,
		.formItem .codeInput::placeholder {
			color: #999;
		}

		.subBox {
			padding-top: 40px;
			display: flex;
			align-items: center;
			justify-content: center;

			/deep/.van-button--disabled {
				opacity: 1;
			}
		}

		/deep/.subBtn {
			width: 100%;
			height: 90px;
			background: #991d85;
			box-shadow: 0px 16px 27px 0px rgba(0, 0, 0, 0.23);
			border-radius: 0;
			font-size: 34px;
			line-height: 1;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
			border: none;
		}

		.reg {
			&::before {
				content: '*';
				color: #9b2743;
			}
		}

		.not_reg {
			&::after {
				content: '（选填）';
				color: #999999;
			}
		}

		.more {
			&::after {
				content: '（可多选）';
				color: #999999;
			}
		}

		.not_more {
			&::after {
				content: '（单选）';
				color: #999999;
			}
		}

		.inputBox,
		.formItemBox {
			width: 100%;
			flex: 0 0 auto;
			display: flex;
			align-items: center;
			background-color: transparent;
			position: relative !important;
			visibility: visible !important;
			/deep/.van-cell {
				// padding: 0 !important;
				background: rgba(255, 255, 255, 0.6);
				box-shadow: 0px 0px 65px 0px rgba(0, 0, 0, 0.08);
				border: none;
				padding: 0 30px !important;
				line-height: 1 !important;
				visibility: visible !important;
				overflow: visible !important;
				&::after {
					display: none !important;
				}
			}

			// /deep/.van-field--error {
			// 	border-color: #d42828;
			// }

			/deep/input {
				color: #000;
				font-size: 30px !important;
				height: 88px;
				line-height: 88px;
				display: block;
				&::placeholder {
					color: #999;
				}
			}

			/deep/textarea {
				padding: 21px 0;
				min-height: 134px;
				line-height: 1.35;
				// border: 1.5px solid #ddd;
				// border-radius: 6px;
			}

			/deep/.van-field--error /deep/.van-field__control,
			/deep/.van-field--error /deep/.van-field__control::placeholder {
				color: #9b2743 !important;
			}

			/deep/.van-field__error-message {
				position: absolute !important;
				right: -30px !important;
				bottom: auto !important;
				top: -20px !important;
				z-index: 1 !important;
				font-size: 26px !important;
				line-height: 1 !important;
				transform: translateY(-100%);
				color: #9b2743 !important;
			}

			.getCode {
				right: 55px;
				top: 50%;
				transform: translateY(-50%);
				position: absolute;
				font-size: 30px;
				font-weight: 500;
				color: #991d85;
				line-height: 1;
				padding: 10px 0;
				&::before {
					content: '';
					display: block;
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%) translateX(-55px);
					width: 1.5px;
					height: 45px;
					background: #dddddd;
				}
			}

			.disabled {
				color: #999 !important;
			}
		}

		.formItemBox {
			/deep/.van-cell {
				box-shadow: none;
				padding: 0 0 0 18px !important;
				border: none !important;
				background-color: transparent;
			}

			/deep/.van-field__error-message {
				top: -29px !important;
				right: 0 !important;
			}

			& > span {
				margin-bottom: 29px;
			}

			/deep/.van-checkbox__label,
			/deep/.van-radio__label {
				font-size: 30px !important;
				color: #000000 !important;
				line-height: 1.2 !important;
				font-weight: bold;
			}
		}

		.pdf {
			// font-size: 26px;
			color: #991d85;
			line-height: 1;
		}

		.clause {
			.img-icon {
				width: 32px;
				height: 32px;
				display: block;
				padding: 20px;
				margin: -20px;
				margin-right: -15px !important;
				box-sizing: content-box;
			}

			::v-deep .van-checkbox {
				align-items: flex-start;
			}

			::v-deep .van-checkbox__label {
				font-size: 26px;
				color: #555555 !important;
				line-height: 36px;
			}
		}
	}

	.notPosition {
		/deep/.van-field__error-message {
			transform: translateY(calc(-100% - 88px - 20px)) !important;
		}
	}

	.email {
		/deep/.van-field__error-message {
			display: flex;
			align-items: center;
			&::before {
				flex: 0 0 auto;
				content: '';
				display: inline-block;
				margin-right: 9px;
				width: 25px;
				height: 26px;
				background-image: url('../assets/images/bang.png');
				background-size: 100% 100%;
				background-position: center center;
				background-repeat: no-repeat;
			}
		}
	}
}

/deep/.uploader {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 11;

	.van-uploader__wrapper {
		width: 100%;
		height: 100%;

		.van-uploader__input-wrapper {
			width: 100%;
			height: 100%;
		}
	}
}
</style>
